/* eslint-disable */
// Had to disable eslint for the entire file because it was falky due to something
// wrong with our setup, it was failing to recognize that this file is being used
// and was complaining.
// TODO: FRONT-5920
import LoadingPlaceholder from 'components/common/LoadingPlaceholder/LoadingPlaceholder';

/**
 * Examples of LoadingPlaceholder.
 */

function LoadingPlaceholderExamplePage(): JSX.Element {
  return (
    <section id="loadingPlaceholder" className="ExamplesPage__Section">
      <h1 className="ExamplesPage__SectionTitle">LoadingPlaceholder</h1>
      <div className="ExamplesPage__Description">Renders a loading spinner (and optional text if specified).</div>
      <div className="ExamplesPage__ExampleRow">
        <h3>LoadingPlaceholder with default options</h3>
        <LoadingPlaceholder />
      </div>
      <div className="ExamplesPage__ExampleRow">
        <h3>LoadingPlaceholder with custom height and offsetTop</h3>
        <LoadingPlaceholder height={100} spinnerHeight={50} offsetTop={20} />
      </div>
      <div className="ExamplesPage__ExampleRow">
        <h3>LoadingPlaceholder with custom text</h3>
        <LoadingPlaceholder description="Launching..." />
      </div>
    </section>
  );
}

export default LoadingPlaceholderExamplePage;
